/**
=========================================================
* Soft UI Dashboard React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/



import React, { useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FormControlLabel, Box } from "@mui/material";
// react-router-dom components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import Table from 'react-bootstrap/Table';
import { Pagination } from "react-bootstrap";
// import { authUserRegistration,authDistributionChannel,authLocation } from '../../../assets/globalAPI/GlobalApi';
// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import {  IconButton, Modal, Dialog, DialogActions, DialogContent, DialogTitle,TextField, Grid, CardContent, CardHeader } from '@mui/material';
// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
import Socials from "layouts/authentication/components/Socials";
import Separator from "layouts/authentication/components/Separator";
import curved9 from "assets/images/anmolb.png";
// import anmolLogo from "../../../assets/images/anmol_logo_transparent.png"
// Images
import curved6 from "assets/images/curved-images/curved14.jpg";
import { createUser } from "assets/globalAPI/apiGlobal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { fetchRoleMaster } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { getAllUsers } from "assets/globalAPI/apiGlobal";
import '../style.css'
import { changePassword } from "assets/globalAPI/apiGlobal";

function ChangePassword() {
  const [agreement, setAgremment] = useState(true);
  const [isActive, setIsActive] = useState(false);
   const [open, setOpen]= useState(false);
  const toastId = React.useRef(null);
  const MySwal = withReactContent(Swal);
  const[userAccess,setUserAccess] = useState('');
  const[userID,setUserID] = useState('');
  const[selectUserType,setSelectUserType] = useState('');
  const[selectDC,setselectDC] = useState('');
  const[newPassword,setNewPassword] = useState('');
  const[confirmNewPassword,setConfirmNewPassword] = useState('');
  const[selectLocation,setSelectLocation] = useState('');
  const[distributionChannel,setDistributionChannel] = useState({});
  const[locationValue,setLocation] = useState({});
  const [desig,setDesig]= useState("")
  const [depart,setDepart]= useState("")
  const [roles,setRoles]=useState([]);
  const [users,setUsers]=useState([]);
  const [selectedRole,setSelectedRole]=useState("");
  const [memberOf,setMemberOf]= useState("")
  const [memberOfName,setMemberOfName]= useState("")
   const [userSearch,setUserSearch]= useState("");
      const typingTimeoutRef = React.useRef(null);
            const latestSearchRef = React.useRef("");
  const navigate = useNavigate();
     const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalPages, setTotalPages]= useState(1);
    const [currentPage, setCurrentPage]= useState(1);
 

  
  const handleSetAgremment = () => setAgremment(!agreement);

  const handleSubmit = async (event) => {
    
    event.preventDefault();
    setIsActive(true)
    let newPassword = document.getElementById('new_password').value;
    let confirmPassword = document.getElementById('confirm_password').value;
   if(newPassword=="" || confirmPassword=="")
   {
    if(! toast.isActive(toastId.current)) {
      toastId.current = toast.warning("Please Fill the Required Fields",{
        className: 'small-toast'
      });  
      setIsActive(false)
      return;
    }
   }else{
    if(newPassword!== confirmPassword){
      if(! toast.isActive(toastId.current)) {
        toastId.current = toast.warning("Password does not match",{
          className
          : "small-toast"
        });  
      }
      setIsActive(false)
      return;
    }
    let myuser = JSON.parse(localStorage.getItem('userdetails'));
    let myid= myuser.id;
    const data = {
     "userId":myid,
    "password":newPassword,
    "confirmPassword":confirmPassword,

    }
    console.log("pass change up body-->",data);
   try{
    const response= await changePassword(data);
    const res= response.data;
    console.log("The response after pass change>> ", res);
    if(res.status){
      if(! toast.isActive(toastId.current)) {
        toastId.current = toast.success(res.message,{
          className: "small-toast"
        });  
      }
      console.log("the success>> ", res);
     setIsActive(false)

    }else{
      if(! toast.isActive(toastId.current)) {
        toastId.current = toast.error(res.message,{
          className: "small-toast"
        });  
      }
      console.log("failed to change>> ", res)
      setIsActive(false)
    }
   }catch(error){
    if(! toast.isActive(toastId.current)) {
      toastId.current = toast.error("Error changing pass",{
        className: "small-toast"
      });  
    }
    setIsActive(false)
    if(error.response?.status==403){
      if(!toast.isActive(toastId.current)){
        toastId.current= toast.error("Your Session has expired",{
          className:"small-toast"
        })
      }
      setTimeout(()=>{
        navigate("/")
        localStorage.clear();
      },2000)
      return;
    }
    console.log("Error in pass change>> ", error)
   }

   }

  }

 

  

  

  return (
    
    <DashboardLayout>

      <DashboardNavbar/>

      <ToastContainer />
      <SimpleBackdrop openLoader={isActive}/>
      <Card sx={{width: "100%", alignSelf: "center", margin: "auto"}}>
        <div style={{width:"80%", margin: "auto", paddingTop: "20px"}}>
        <SoftBox p={3} s >
          <SoftTypography variant="h5" fontWeight="medium">
            Change Password
          </SoftTypography>
        </SoftBox>
        
       
        <SoftBox pt={0} pb={3} px={3}>
          <SoftBox>
          <form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <SoftBox mb={2}>
                  <SoftInput type="password" placeholder="New Password" name="new_password" id="new_password" />
                </SoftBox>
              </Grid>
              <Grid item xs={12} sm={6}>
                <SoftBox mb={2}>
                <SoftInput type="password" placeholder="Confirm Password" name="confirm_password" id="confirm_password" />
                </SoftBox>
              </Grid>

            </Grid>
            <SoftBox mt={4} mb={1}>
              <SoftButton variant="gradient" color="error" fullWidth type="submit">
                Submit
              </SoftButton>
            </SoftBox>
            </form>
          </SoftBox>
        </SoftBox>

        </div>
        
        
        
      </Card>
    </DashboardLayout>
      
  );
}

export default ChangePassword;
